import React from 'react'

import {
    Uniform,
    UniformLayouts,
    calculateLayoutsLength,
} from 'component-library/collections-new/Uniform/Uniform'
import { ContentDataDefinitionLoader } from 'common/data/loader-definitions'
import { CollectionRouteProps } from 'component-library/collections-new/collections-props.routing'
import { Section } from 'component-library/__styling/settings/sections'
import { CardOrientationOptions } from 'component-library/cards/Portrait/Portrait'
import { createRegisterableComponentWithData } from 'common/routing/page-definition'

export interface UniformRouteProps extends CollectionRouteProps {
    disableImageLazyLoad?: boolean
    section: Section
    cardLayout: UniformLayouts
    cardOrientation?: CardOrientationOptions
}

export const UniformRegistration = createRegisterableComponentWithData(
    'uniform',
    ContentDataDefinitionLoader,
    (props: UniformRouteProps, data, services) => {
        return (
            <Uniform
                items={
                    data.loaded
                        ? { loaded: true, result: data.result.publications }
                        : { loaded: false }
                }
                expectedCards={calculateLayoutsLength(props.cardLayout)}
                disableImageLazyLoad={props.disableImageLazyLoad}
                onEvent={services.onEvent}
                section={props.section}
                sectionHeader={props.sectionHeader}
                verticalSpacing={props.verticalSpacing}
                cardLayout={props.cardLayout}
                cardOrientation={props.cardOrientation}
            />
        )
    }
)
